import React from 'react';
import { useRouteMatch } from 'react-router';

import ShareClub from '../../../ShareClub/ShareClub';

import { TXTCLI_Share } from './ShareButton.messages.json';
import styles from './ShareButton.scss';
import ShareIcon from './assets/share.svg';

const ShareButton: React.FC = () => {
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();

  return (
    <ShareClub
      clubId={Number(clubId)}
      buttonProps={{
        className: styles.button,
        translation: TXTCLI_Share,
        icon: <ShareIcon />,
        variant: 'text'
      }}
    />
  );
};

export default ShareButton;
